import styled, { css } from 'styled-components';
import { spacing } from '../../../../stylings';

export const MenuColumnContainer = styled.div<{ $hasFeaturedCards: boolean; $extendWidth?: boolean }>`
  display: flex;
  ${({ $hasFeaturedCards }) =>
    !$hasFeaturedCards &&
    css`
      flex-basis: content;
      flex-grow: 1;
    `}
  flex-direction: column;
  max-width: ${({ $extendWidth }) => ($extendWidth ? '255px' : '190px')};
`;

export const MenuColumnContent = styled.ul`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing.M};
  max-width: 190px;
  padding: 0;
  width: fit-content;
`;
